import React from 'react';

interface ProjectAreaLayoutProps {
  children: React.ReactNode;
  className?: string;
}

const ProjectAreaLayout: React.FC<ProjectAreaLayoutProps> = ({ children, className = '' }) => (
  <div className={`project-area-layout dashboard-page ${className}`.trim()}>
    {children}
  </div>
);

export default ProjectAreaLayout;
